import React, { useEffect, useState,useContext } from 'react';
import {
  Box, Typography, Grid, Chip, Card, CardContent, IconButton, Paper, Container,Button
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import BedIcon from '@mui/icons-material/Bed';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ElevatorIcon from '@mui/icons-material/Elevator';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BalconyIcon from '@mui/icons-material/Balcony';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import OpacityIcon from '@mui/icons-material/Opacity';
import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import buildingImage from './../../../Images/house.jpeg';
import CustomBottomNav from './CustomBottomNav';
import { BASE_URL } from './../../Api/ApiUrls';
import { AuthContext } from './../../AuthContext/AuthContext';
const NewBuildingsDescription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId, logout } = useContext(AuthContext);
    const { propertyId } = location.state || {};
  const [categories, setCategories] = useState([]);
  const [property, setProperty] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  // Set images to a default

  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
    const [featureRequested, setFeatureRequested] = useState('');
    const [userPlan, setUserPlan] = useState(null);
    
// Add these state variables at the top with your other states
const [userActivities, setUserActivities] = useState([]);
const [showLimitModal, setShowLimitModal] = useState(false);
  const handleImageClick = (image) => {
    setSelectedImage(image);
  };


useEffect(() => {
  const checkSubscription = async () => {
    try {
      console.log('Checking subscription for user:', userId);
      const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
      const userSubscription = response.data;

      console.log('Found subscription:', userSubscription);
      setUserPlan(userSubscription); // Store the entire plan object

      // Check both status and user_type
      if (userSubscription && userSubscription.user_type === "Buyer") {
        console.log('User is subscribed and is a Buyer');
        setIsSubscribed(true);
      } else {
        console.log('User is NOT subscribed or not a Buyer');
        setIsSubscribed(false);
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      setIsSubscribed(false);
      setUserPlan(null);
    }
  };

  if (userId) {
    checkSubscription();
  } else {
    console.log('No user ID, defaulting to non-subscribed state');
    setIsSubscribed(false);
    setUserPlan(null);
  }
}, [userId]);


// Add this useEffect to fetch user activities
useEffect(() => {
  const fetchUserActivities = async () => {
    if (!userId) {
      console.log('No userId - skipping activity fetch');
      return;
    }
    
    try {
      console.log(`Fetching activities for user ${userId}`);
      const response = await fetch(`${BASE_URL}/activities/`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const allActivities = await response.json();
      console.log('All activities from API:', allActivities);
      
      // Filter activities for the current user
      const filteredActivities = allActivities.filter(activity => 
        activity && activity.user_id !== undefined && 
        String(activity.user_id) === String(userId)
      );
      
      console.log('Filtered user activities:', filteredActivities);
      setUserActivities(filteredActivities);
    } catch (error) {
      console.error('Error fetching activities:', error);
      setUserActivities([]);
    }
  };

  fetchUserActivities();
}, [userId]);

// Enhanced property limit check with dynamic limits
const checkPropertyLimit = (currentPropertyId) => {
  if (!isSubscribed) {
    console.log('Non-subscriber - access denied');
    setFeatureRequested("Property Access");
    setShowSubscribeModal(true);
    return false;
  }

  // If unlimited access is granted
  if (userPlan?.no_of_properties_unlimited) {
    console.log('User has unlimited property access');
    return true;
  }

  const uniqueProperties = new Set(userActivities.map(a => a.property_id));
  const isExistingProperty = uniqueProperties.has(currentPropertyId);
  
  console.log(`User has accessed ${uniqueProperties.size} unique properties`);
  console.log(`Is current property already accessed? ${isExistingProperty}`);

  // Get the dynamic limit from user plan, default to 10 if not available
  const propertyLimit = userPlan?.no_of_properties || 10;
  
  if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
    console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
    setShowLimitModal(true);
    return false;
  }
  
  return true;
};


  const fieldMap = {
    'Commercial land/plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
    'Plot/land': ['Site Area', 'Facing', 'Price', 'Road Width'],
    'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms', 'Lift', 'Road Width'],
    'Duplex house': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms', 'Lift', 'Road Width'],
    'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count', 'Lift', 'Road Width'],
    'Pg-offices': ['Property Name', 'Site Area', 'Facing', 'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
    'Flat': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
    'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Commercial building': ['Property Name', 'Site Area', 'Facing', 'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Apartment': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
    'JV/JD': ['Site Area', 'Facing', 'Price', 'Road Width'],
  };


  const images = property?.property_images && property.property_images.length > 0
    ? property.property_images.map(img => `${BASE_URL}${img.image}`)
    : [buildingImage];

  // const handleImageClick = (image) => {
  //   setSelectedImage(image); // Update selected image
  // };

 const handleLocationClick = () => {
  // Check subscription first
  if (!isSubscribed) {
    setFeatureRequested("Location Access");
    setShowSubscribeModal(true);
    return;
  }

  // Check property limit
  if (!checkPropertyLimit(property.id)) {
    return;
  }

  // Log activity before opening maps
  const logActivity = async () => {
    try {
      const response = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: property.id,
          activity_type: "Location",
          property_by: property.owner
        })
      });

      if (!response.ok) throw new Error('Failed to log location activity');
      
      const newActivity = await response.json();
      console.log('Location activity logged:', newActivity);
      setUserActivities(prev => [...prev, newActivity]);
    } catch (err) {
      console.error("Error logging location activity:", err);
    }
  };

  // Execute the location functionality
  const openLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLong = position.coords.longitude;

          if (property?.lat && property?.long) {
            const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLong}&destination=${property.lat},${property.long}&travelmode=driving`;
            window.open(mapsUrl, '_blank');
          } else if (property?.loc) {
            const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc)}`;
            window.open(mapsUrl, '_blank');
          }
        },
        (error) => {
          console.error("Error getting user location:", error);
          if (property?.lat && property?.long) {
            const mapsUrl = `https://www.google.com/maps/?q=${property.lat},${property.long}`;
            window.open(mapsUrl, '_blank');
          } else if (property?.loc) {
            const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc)}`;
            window.open(mapsUrl, '_blank');
          }
        }
      );
    } else {
      if (property?.lat && property?.long) {
        const mapsUrl = `https://www.google.com/maps/?q=${property.lat},${property.long}`;
        window.open(mapsUrl, '_blank');
      } else if (property?.loc) {
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc)}`;
        window.open(mapsUrl, '_blank');
      }
    }
  };

  // First log the activity, then open location
  logActivity().then(openLocation);
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories first
        const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesRes.data);

        // Then fetch property if propertyId exists
        if (propertyId) {
          const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
          setProperty(propertyRes.data);
          //setImages(propertyRes.data.images || [buildingImage]); // Set images from property
        }
      } catch (err) {
        console.error('Failed to fetch data:', err);
      }
    };

    fetchData();
  }, [propertyId]);

  if (!property) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Typography>Loading property...</Typography>
      </Box>
    );
  }

    
  

  const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
  const categoryName = propertyCategory ? propertyCategory.category : property.type;

  const fieldsToDisplay = fieldMap[categoryName] || [];
 const hideBuiltUpAndFloor = [
  'commercial land/plot', 
  'plot/land',
  'jv/jd', 
 
].includes(categoryName?.trim().toLowerCase());

  const excludedDisplayFields = [
  'Site Area',
  'Facing',
  'Price',
  'Road Width',
  'No.of Floors',
  'Buildup Area'
];

  const propertyDetails = fieldsToDisplay.map((field) => {
    switch (field) {
      case 'Site Area':
        return { label: 'Site Area', value: `${property.site_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
      case 'Facing':
        return { label: 'Facing', value: property.facing?.replace(/"/g, '') || 'NA', icon: <CompassCalibrationOutlinedIcon /> };
      case 'Price':
        return { label: 'Price', value: property.price ? property.price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }) : 'NA', icon: <SecurityOutlinedIcon /> };
      case 'Road Width':
        return { label: 'Road Width', value: `${property.roadwidth || 'NA'} ft`, icon: <CropSquareOutlinedIcon /> };
      case 'No.of Floors':
        return { label: 'No. of Floors', value: `${property.no_of_flores || 'NA'}`, icon: <LayersOutlinedIcon /> };
      case 'Buildup Area':
        return { label: 'Buildup Area', value: `${property.buildup_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
      case 'Borewell':
        return { label: 'Bore Well', value: property.borewell === 'Yes' ? 'Available' : property.borewell === 'No' ? 'Not Available' : 'NA', icon: <OpacityIcon /> };
      case 'No.of Cars Parking':
        return { label: 'No. of Cars Parking', value: `${property.parking || 'NA'}`, icon: <DirectionsCarIcon /> };
      case '1bhk Count':
        return { label: '1 BHK Count', value: property._1bhk_count || 'NA', icon: <BedIcon /> };
      case '2bhk Count':
        return { label: '2 BHK Count', value: property._2bhk_count || 'NA', icon: <BedIcon /> };
      case '3bhk Count':
        return { label: '3 BHK Count', value: property._3bhk_count || 'NA', icon: <BedIcon /> };
      case '4bhk Count':
        return { label: '4 BHK Count', value: property._4bhk_count || 'NA', icon: <BedIcon /> };
      case 'Duplex Bedrooms':
        return { label: 'Duplex Bedrooms', value: property.duplex_bedrooms || 'NA', icon: <BedIcon /> };
      case 'Lift':
        return { label: 'Lift', value: property.lift === 'Yes' ? 'Available' : property.lift === 'No' ? 'Not Available' : 'NA', icon: <ElevatorIcon /> };
      case 'House Count':
        return { label: 'House Count', value: property.house_count || 'NA', icon: <HomeWorkIcon /> };
      default:
        return null;
    }})
 .filter(detail => detail !== null && !excludedDisplayFields.includes(detail.label));

  const groupedPropertyDetails = [];
for (let i = 0; i < propertyDetails.length; i += 2) {
  groupedPropertyDetails.push(propertyDetails.slice(i, i + 2));
}


  return (
    <Box sx={{ width: '100vw', minHeight: '100vh', backgroundColor: 'rgb(239, 231, 221)', pb: 10 }}>
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        bgcolor: 'rgb(49, 48, 49)',
        color: 'white',
        p: 2,
        display: 'flex',
        alignItems: 'center',
      }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1 }}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography variant="h6" fontWeight="bold">
          {categoryName?.replace(/"/g, '') || 'Property Type'}
        </Typography>
      </Box>

      <Box sx={{ pt: '80px', px: 2 }}>
        <Card sx={{
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #ffffff 0%,rgb(248, 248, 248) 100%)',
          boxShadow: 5,
        }}>
          {images.length > 1 ? (
            <Carousel
              selectedItem={images.indexOf(selectedImage)}
              showThumbs={false}
              showArrows={false}
              autoPlay
              infiniteLoop
              interval={3000}
              showIndicators={true}
              showStatus={false}
              swipeable
              emulateTouch
              dynamicHeight
              stopOnHover
              transitionTime={600}
              swipeScrollTolerance={5}
              useKeyboardArrows
            >
              {images.map((image, index) => (
                <Box
                  key={index}
                  component="img"
                  src={image}
                  alt="Property"
                  loading="lazy"
                  sx={{
                    width: '100%',
                    height: { xs: 250, sm: 300, md: 400 },
                    objectFit: 'cover',
                    borderTopLeftRadius: '20px',
                    borderTopRightRadius: '20px',
                  }}
                />
              ))}
            </Carousel>
          ) : (
            <Box
              component="img"
              src={images[0]}
              alt="Property"
              loading="lazy"
              sx={{
                width: '100%',
                height: { xs: 250, sm: 300, md: 400 },
                objectFit: 'cover',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
              }}
            />
          )}

          {/* Thumbnail Images */}
          <Container sx={{ mt: 3 }}>
            <Box sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: 2,
              pb: 1,
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}>
              {images.map((image, index) => (
                <Box
                  key={index}
                  onClick={() => handleImageClick(image)}
                  sx={{
                    minWidth: 100,
                    height: 80,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    position: 'relative',
                    cursor: 'pointer',
                    boxShadow: selectedImage == image
                      ? '0px 4px 20px rgba(0, 0, 0, 0.3)'
                      : '0px 2px 8px rgba(0, 0, 0, 0.1)',
                    transform: selectedImage == image ? 'scale(1.08)' : 'scale(1)',
                    transition: 'all 0.4s ease',
                    border: selectedImage == image ? '2px solid #1976d2' : '2px solid transparent',
                    flexShrink: 0,
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={image}
                    alt={`Thumbnail ${index + 1}`}
                    loading="lazy"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Container>

          <CardContent>
            <Typography fontWeight="bold" fontSize="18px">
              {categoryName?.replace(/"/g, '')} - {property.property_name || 'Property Type'}
            </Typography>
            <Grid item sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <Typography 
              variant="caption" 
              color="text.secondary" 
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                maxWidth: '200px', // Adjust as needed
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                 
                
              }}
              
               onClick={handleLocationClick}
            >
              <LocationOnIcon sx={{ fontSize: '16px', mr: 0.5,color: 'primary.main' }} />
              {property.location ? `${property.location.substring(0, 25)}${property.location.length > 25 ? '...' : ''}` : 'Not Specified'}
            </Typography>
             <Typography fontWeight="bold" fontSize="18px" marginLeft="100px" color="rgb(240, 65, 30)">
              {property.price
              ? property.price.toLocaleString('en-IN', {
                  style: 'currency',
                  currency: 'INR',
                  minimumFractionDigits: 0,
                })
              : 'NA'}
            
            </Typography>
            
              </Grid>

            <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          bgcolor: '#ede7f6',
                          borderRadius: 2,
                          p: 2,
                          mb: 2,
                        }}>
                          <Box sx={{ textAlign: 'center', flex: 1 }}>
                            <Typography fontWeight="bold" color="primary">
                              {property.site_area || 'NA'} sq ft
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Site Area
                            </Typography>
                          </Box>
            
                          <Box sx={{ textAlign: 'center', flex: 1 }}>
                            <Typography fontWeight="bold" color="primary">
                              {property.roadwidth || 'NA'} ft
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Road Width
                            </Typography>
                          </Box>
            
                          <Box sx={{ textAlign: 'center', flex: 1 }}>
                            <Typography fontWeight="bold" color="primary">
                              {property.facing?.replace(/"/g, '') || 'NA'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Facing
                            </Typography>
                          </Box>
                        </Box>

            {/* <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              bgcolor: '#ede7f6',
              borderRadius: 2,
              p: 2,
              mb: 2,
            }}>
             
              {propertyDetails.map((detail, i) => (
                <Box key={i} sx={{ textAlign: 'center', flex: 1 }}>
                  <Typography fontWeight="bold" color="primary">
                    {detail.value}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {detail.label}
                  </Typography>
                </Box>
              ))}
            </Box> */}

            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
  <Typography variant="subtitle1" fontWeight="bold">
    Overview:
  </Typography>
  <Typography variant="subtitle1" fontWeight="bold">
  Posted: <span style={{ fontWeight: 'normal' }}>{property.posted_by || 'No overview provided.'}</span>
</Typography>
</Box>

<Box
  sx={{
    border: '2px solid #424242',
    borderRadius: 2,
    overflow: 'hidden',
  }}
>
  {groupedPropertyDetails.map((row, rowIndex) => (
    <Box key={rowIndex} sx={{ display: 'flex', width: '100%' }}>
      {row.map((item, colIndex) => (
        <Box
          key={colIndex}
          sx={{
            flex: '0 0 50%',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            p: 1.5,
            boxSizing: 'border-box',
            borderRight: colIndex === 0 ? '1px solid #9e9e9e' : 'none',
            borderBottom: '1px solid #9e9e9e',
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              color: 'rgb(50, 47, 52)',
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {item.icon}
          </Box>
          <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
            <Typography
              fontWeight={500}
              fontSize="0.875rem"
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: 1.3,
              }}
            >
              {item.value}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              fontSize="0.75rem"
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: 1.3,
              }}
            >
              {item.label}
            </Typography>
          </Box>
        </Box>
      ))}
      {row.length === 1 && (
        <Box sx={{ flex: '0 0 50%', borderBottom: '1px solid #9e9e9e' }} />
      )}
    </Box>
  ))}
</Box>

 {!hideBuiltUpAndFloor && (
<Box sx={{ mt: 3, borderTop: '1px dashed #d1c4e9', pt: 2 }}>
              {[
                ['Built Up Area', `${property.buildup_area || 'NA'} Sq.ft`, <CropSquareOutlinedIcon />],
                ['Facing', property.facing?.replace(/"/g, '') || 'NA', <CompassCalibrationOutlinedIcon />],
                ['Floor', `${property.no_of_flores || 'NA'}`, <LayersOutlinedIcon />],
               
              ].map(([label, value, icon], i) => (
                <Box
                  key={i}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: i !== 3 ? 1.5 : 0,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', color: 'rgb(52, 50, 53)' }}>
                    {icon}
                    <Typography fontSize={14} sx={{ ml: 1 }} color="text.primary">
                      {label}
                    </Typography>
                  </Box>
                  <Typography fontWeight={500} color="text.primary" fontSize={14}>
                    {value}
                  </Typography>
                </Box>
              ))}
            </Box>
                 )}
          </CardContent>
        </Card>
      </Box>

      {/* Bottom Navigation */}
 {showSubscribeModal && (
              <Box sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
                  <Typography variant="h6" gutterBottom>
                    Subscription Required
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Please subscribe to use the {featureRequested} feature.
                  </Typography>
                  <Button 
                    variant="contained" 
                    color="primary"
                    onClick={() => setShowSubscribeModal(false)}
                  >
                    OK
                  </Button>
                </Paper>
              </Box>
            )}

  
{/* Limit Exceeded Modal */}
{showLimitModal && (
  <Box sx={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        Limit Exceeded
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {userPlan?.no_of_properties_unlimited 
          ? "You have unlimited access to properties."
          : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. 
             Please upgrade your subscription plan for more.`
        }
      </Typography>
      <Button 
        variant="contained" 
        color="primary"
        onClick={() => setShowLimitModal(false)}
      >
        OK
      </Button>
    </Paper>
  </Box>
)}      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <CustomBottomNav />
      </Paper>
    </Box>
  );
};

export default NewBuildingsDescription;
